import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetAvailCompTables,
    GetAvailCompColumns,
    CreateCompanion,
    GetCompanionList
 } from '../../../actions/CompanionActions';
import AutoComplete from '../../../components/AutoComplete';



const NewCompanion = (props) => {
    const dispatch = useDispatch();
    const companionInfo = useSelector(state => state.companionInfo.value);
    const [compTables, setCompTables] = useState([]);
    const [selTable, setSelTable] = useState('');
    const [selColumns, setSelColumns] = useState([]);
    const [compName, setCompName] = useState('');

    useEffect(() => {
        GetAvailCompTables(tableCallBack);
    }, [])

    useEffect(() => {
        if(selTable !== '') {
            setSelColumns([]);
            setCompName(selTable);
        }
    }, [selTable])

    const tableCallBack = (tables) => {
        if(tables)
        {
            let oTables = [];
            tables.forEach((t) => {
                let extComp = companionInfo.companions.find(c => c.companionTable === t);
                if(extComp === undefined)
                {
                    oTables.push({
                        text: t,
                        val: t
                    });
                }
            });
            setCompTables(oTables);
        }
    }

    const fetchColumns = () => {
        GetAvailCompColumns(selTable, fetchColumnCallback);
    }

    const fetchColumnCallback = (res) => {
        console.log(res);
        let cols = [];
        res.forEach((col) => {
            cols.push({
                colName: col,
                isSelected: false,
                isId: false,
                readOnly: false
            });
        });
        setSelColumns(cols);
    }

    const createCompanionClick = () => {
        let newComp = {
            tableName: selTable,
            compName: compName,
            columns: []
        };
        selColumns.forEach(col => {
            if(col.isSelected) {
                newComp.columns.push({
                    colName: col.colName,
                    isReadOnly: col.readOnly,
                    isIdCol: col.isId
                });
            }
        });
        CreateCompanion(newComp, dispatch, afterCreate)

    }

    const afterCreate = () => {
        GetCompanionList(dispatch);
        props.close();
    }

    const changeCheck = (e, col, type) => {
        let columns = [...selColumns];
        let editCol = columns.find(f => f.colName === col.colName);
        if(editCol) {
            switch(type) {
                case 'show':
                    editCol.isSelected = e.target.checked;
                    break;
                case 'id':
                    let otherId = columns.find(f2 => f2.isId === true);
                    if(otherId) {
                        otherId.isId = false;
                    }
                    editCol.isId = e.target.checked;

                    break;
                case 'readonly':
                    editCol.readOnly = e.target.checked;
                    break;
            }
            setSelColumns(columns);
        }
    }

    return (
    <div className='td-dialogue-container'>
        <div className='td-dialogue card' style={{ width: '400px', height: '550px' }}>
            <div className='card-header'>
                New Companion Table
                <button
                  type='button'
                  className='btn-close'
                  onClick={() => props.close()}
                />
              </div>
              <div
                className='card-body ps-4'
                style={{ maxHeight: '500px', overflow: 'auto' }}
              >
                <label className='form-label'>Companion Table:</label>
                <AutoComplete
                    allowedValues= {compTables}
                    displayField='text'
                    valueField='val'
                    value={selTable}
                    onChange={(v) => setSelTable(v)}

                />

                {selTable !== '' && <div className='mt-3'>
                    <button className='btn btn-primary' onClick={fetchColumns}>Fetch Columns ...</button>
                    <div className='mt-2 coolScroll' style={{height: '180px', maxHeight: '180px', width: '350px', overflow : 'auto'}}>
                        <table>
                            <thead>
                                <tr>
                                    <th style={{minWidth: '150px'}}>Column</th>
                                    <th>Show</th>
                                    <th className='ps-2'>Id col</th>
                                    <th className='ps-2'>Read Only</th>
                                </tr>
                            </thead>
                            <tbody>
                                {selColumns.map((col) => (
                                    <tr key={col.colName}>
                                        <td>{col.colName}</td>
                                        <td className='ps-2'><input className='form-check-input' onChange={(e) => changeCheck(e, col, 'show')} type='checkbox' checked={col.isSelected} /></td>
                                        <td className='ps-3'><input className='form-check-input' onChange={(e) => changeCheck(e, col, 'id')} type='checkbox' checked={col.isId} /></td>
                                        <td className='ps-3'><input className='form-check-input' onChange={(e) => changeCheck(e, col, 'readonly')} type='checkbox' checked={col.readOnly} /></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                    </div>
                    <label className='form-label'>Companion Name:</label>
                    <input value={compName} onChange={(v) => setCompName(v.target.value)} className='form-control'></input>
                    <div className='d-grid gap-2'>
                        <button onClick={createCompanionClick} className='btn btn-primary mt-2'> Create Companion </button>
                    </div>


                </div>}


            </div>
        </div>
    </div>
    );
}

export default NewCompanion;